'use strict';
import {createActions} from '../../framework';

const normalActions = [
  'CLOSE_DROPDOWN',
  'OPEN_DROPDOWN',
  'RESET_STORE',
  'SET_SELECTED_ITEM',
  'SET_STORE_NAME'
];

const blockyDropdownActions = createActions(null, normalActions);

export default blockyDropdownActions;
